var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentDaysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.196289,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E6F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6665 16.696H29.8332V15.0293H28.1665V16.696H19.8332V15.0293H18.1665V16.696H17.3332C16.4165 16.696 15.6665 17.446 15.6665 18.3626V31.696C15.6665 32.6126 16.4165 33.3626 17.3332 33.3626H30.6665C31.5832 33.3626 32.3332 32.6126 32.3332 31.696V18.3626C32.3332 17.446 31.5832 16.696 30.6665 16.696ZM30.6665 31.696H17.3332V22.5293H30.6665V31.696ZM30.6665 20.8626H17.3332V18.3626H30.6665V20.8626Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentDaysIcon);
export default __webpack_public_path__ + "static/media/presentDaysIcon.5b4bd9c086f3a00f23498c069bf29b9d.svg";
export { ForwardRef as ReactComponent };